import type { VoidFunctionComponent } from 'react';

import Button from '../../../generic/Button/Button';
import FormGroup from '../../../generic/Forms/FormGroup';
import LabeledTextInput from '../../../generic/Forms/LabeledTextInput';
import type { BowerRegistry } from '../../../../../typings/auth';

type RegistryProps = {
  registry: BowerRegistry;
  onRemoveRegistry: () => void;
  onUpdateRegistryURL: (value: string) => void;
  isRemoveDisabled: boolean;
};

const Registry: VoidFunctionComponent<RegistryProps> = ({
  registry,
  onRemoveRegistry,
  onUpdateRegistryURL,
  isRemoveDisabled,
}) => (
  <div className="margin-bottom-sm">
    <FormGroup direction="row" spacing="sm" baselineAlignment>
      <LabeledTextInput
        labelVariant="legacy"
        label="URL"
        size="small"
        value={registry.hasUrl ? '••••••••' : registry.url?.value || ''}
        onChange={onUpdateRegistryURL}
        placeholder="https://bower.mycompany.com"
      />
      <Button
        type="error"
        size="small"
        onClick={onRemoveRegistry}
        isDisabled={isRemoveDisabled}
      >
        Remove
      </Button>
    </FormGroup>
  </div>
);

export default Registry;
